import { strayLabelsCypherExpr } from './stray'

/** Resolve one ontology entity and all of its labels by stable application id. */
export const PLANT_ENTITY_RESOLVE_CYPHER = `
  MATCH (n {id: $id})
  WITH n, labels(n) AS labels
  RETURN n, labels, ${strayLabelsCypherExpr('n', 'labels')} AS strayLabels
  LIMIT 1
`
